import React from 'react';

export default function Bold({ children }) {
  return <span className="font-weight-500">{children}</span>;
}
